export default "__VITE_ASSET__eeefdad0__"